import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { ComingSoon } from '@/components/shared/ComingSoon';

export const Route = createFileRoute('/koledar')({
  component: KoledarPage,
});

function KoledarPage() {
  return (
    <AppShell pageTitle="Koledar" crumb="TradeCraft · Koledar">
      <ComingSoon
        headline="Koledar"
        lead="AI agent samodejno vpisuje dogovorjene termine iz klicev v vaš delovni urnik."
      />
    </AppShell>
  );
}
